<template>
  <div class="consulAddDialog">
    <div class="queRenBtn">
      <el-button type="primary" class="basicInfo">基础信息</el-button>
    </div>
    <table class="basicTable">
      <tr>
        <th>议题编号</th>
        <th>村/社区</th>
        <th>议题来源</th>
        <th>协商内容</th>
        <th>利益双方</th>
        <th>议题确定</th>
      </tr>
      <tr>
        <!-- <td>{{communityName}}</td> -->
        <!-- <td>
          <textarea type="text" disabled style="width:99%;height:99%;border:none;resize:none" v-model="content" readonly></textarea>
        </td> -->
        <td>{{consultNumber}}</td>
        <td>{{communityName}}</td>
        <td>{{issueSource}}</td>
        <td>
          <div v-show-tips class="tdspan">{{negotiationContent}}</div>
        </td>
        <td>{{ccList}}</td>
        <td>{{consultSure}}</td>
      </tr>
      <tr>
        <th>镇/街道</th>
        <th>议题的内容</th>
        <th>议题类型</th>
        <th>议题层级</th>
        <th>处理方式如何协调</th>
        <th>确定方式</th>
        <!-- <th></th> -->
      </tr>
      <tr>
        <td>{{streetName}}</td>
        <td>
          <div v-show-tips class="tdspan">{{content}}</div>
          
          <!-- <textarea type="text" disabled style="width:99%;height:99%;border:none;resize:none" v-model="content" readonly></textarea> -->
        </td>
        <td>{{consultTypeName}}</td>
        <td>{{bargainingLevel}}</td>
        <td> 
          <div v-show-tips class="tdspan">{{coordinateMethod}}</div>
        </td>
        <td>{{confirmateMethod}}</td>
        <!-- <td></td> -->
      </tr>
    </table>
    <div class="queRenBtn">
      <el-button type="primary" class="basicSecord">办理记录</el-button>
    </div>
    <table class="basicTable">
      <tr>
        <th>时间</th>
        <th>地点</th>
        <th>主持人</th>
        <th>记录人</th>
      </tr>
      <tr>
        <td>{{handleTime}}</td>
        <td>{{handlePlace}}</td>
        <td>{{host}}</td>
        <td>{{record}}</td>
      </tr>
      <tr>
        <th>议事协商记录</th>
        <th>协商结果</th>
        <th>图片</th>
        <th></th>
      </tr>
      <tr>
        <td>
          <div v-show-tips class="tdspan">{{noteTaker}}</div>
          <!-- <textarea type="text" disabled style="width:99%;height:99%;border:none;resize:none" v-model="noteTaker"></textarea> -->
          </td>
        <td>{{approvalStatus}}</td>
        <td>
          <img :src="photo" alt="" style="width:50px;height:50px;">
        </td>
        <td></td>
      </tr>
    </table>
    <div class="queRenBtn">
    <el-button v-if="handleTime1" type="primary" class="basicSecord">第二次办理记录</el-button>
    </div>
    <table v-if="handleTime1" class="basicTable">
      <tr>
        <th>时间</th>
        <th>地点</th>
        <th>主持人</th>
        <th>记录人</th>
      </tr>
      <tr>
        <td>{{handleTime1}}</td>
        <td>{{handlePlace1}}</td>
        <td>{{host1}}</td>
        <td>{{record1}}</td>
      </tr>
      <tr>
        <th>议事协商记录</th>
        <th>协商结果</th>
        <th>图片</th>
        <th></th>
      </tr>
      <tr>
        <td>
          <div v-show-tips class="tdspan">{{noteTaker1}}</div>
          <!-- <textarea type="text" disabled style="width:99%;height:99%;border:none;resize:none" v-model="noteTaker1"></textarea> -->
          </td>
        <td>{{approvalStatus1}}</td>
        <td>
          <img :src="photo1" alt="" style="width:50px;height:50px;">
        </td>
        <td></td>
      </tr>
    </table>
     <div class="queRenBtn">
    <el-button v-if="handleTime2" type="primary" class="basicSecord">第三次办理记录</el-button>
    </div>
    <table v-if="handleTime2" class="basicTable">
      <tr>
        <th>时间</th>
        <th>地点</th>
        <th>主持人</th>
        <th>记录人</th>
      </tr>
      <tr>
        <td>{{handleTime2}}</td>
        <td>{{handlePlace2}}</td>
        <td>{{host2}}</td>
        <td>{{record2}}</td>
      </tr>
      <tr>
        <th>议事协商记录</th>
        <th>协商结果</th>
        <th>图片</th>
        <th></th>
      </tr>
      <tr>
        <td>
          <div v-show-tips class="tdspan">{{noteTaker2}}</div>
          <!-- <textarea type="text" disabled style="width:99%;height:99%;border:none;resize:none" v-model="noteTaker2"></textarea> -->
          </td>
        <td>{{approvalStatus2}}</td>
        <td>
          <img :src="photo2" alt="" style="width:50px;height:50px;">
        </td>
        <td></td>
      </tr>
    </table>
    <div class="queRenBtn">
    <el-button v-if="handleTime3" type="primary" class="basicSecord">第四次办理记录</el-button>
    </div>
    <table v-if="handleTime3" class="basicTable">
      <tr>
        <th>时间</th>
        <th>地点</th>
        <th>主持人</th>
        <th>记录人</th>
      </tr>
      <tr>
        <td>{{handleTime3}}</td>
        <td>{{handlePlace3}}</td>
        <td>{{host3}}</td>
        <td>{{record3}}</td>
      </tr>
      <tr>
        <th>议事协商记录</th>
        <th>协商结果</th>
        <th>图片</th>
        <th></th>
      </tr>
      <tr>
        <td>
          <div v-show-tips class="tdspan">{{noteTaker3}}</div>
          <!-- <textarea type="text" disabled style="width:99%;height:99%;border:none;resize:none" v-model="noteTaker3"></textarea> -->
          </td>
        <td>{{approvalStatus3}}</td>
        <td>
          <img :src="photo3" alt="" style="width:50px;height:50px;">
        </td>
        <td></td>
      </tr>
    </table>
    <div class="queRenBtn">
    <el-button v-if="handleTime4" type="primary" class="basicSecord">第五次办理记录</el-button>
    </div>
    <table v-if="handleTime4" class="basicTable">
      <tr>
        <th>时间</th>
        <th>地点</th>
        <th>主持人</th>
        <th>记录人</th>
      </tr>
      <tr>
        <td>{{handleTime4}}</td>
        <td>{{handlePlace4}}</td>
        <td>{{host4}}</td>
        <td>{{record4}}</td>
      </tr>
      <tr>
        <th>议事协商记录</th>
        <th>协商结果</th>
        <th>图片</th>
        <th></th>
      </tr>
      <tr>
        <td>
          <div v-show-tips class="tdspan">{{noteTaker4}}</div>
          <!-- <textarea type="text" disabled style="width:99%;height:99%;border:none;resize:none" v-model="noteTaker4"></textarea> -->
          </td>
        <td>{{approvalStatus4}}</td>
        <td>
          <img :src="photo4" alt="" style="width:50px;height:50px;">
        </td>
        <td></td>
      </tr>
    </table>
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
export default {
  props: ["ytid"],
  data() {
    return {
      id: this.ytid,
      communityName: '',
      consultTypeName: '',
      consultSure: '',
      content: '',
      bargainingLevel: '',
      issueSource: '',
      liyiList: [],
      ccList: [],
      handleTime: '',
      handlePlace: '',
      host: '',
      record: '',
      noteTaker: '',
      approvalStatus: '',
      photo: '',
      handleTime1: '',
      handlePlace1: '',
      host1: '',
      record1: '',
      approvalStatus1: '',
      photo1: '',
      noteTaker1: '',
      handleTime2: '',
      handlePlace2: '',
      host2: '',
      record2: '',
      approvalStatus2: '',
      photo2: '',
      noteTaker2: '',

      handleTime3: '',
      handlePlace3: '',
      host3: '',
      record3: '',
      approvalStatus3: '',
      photo3: '',
      noteTaker3: '',

      handleTime4: '',
      handlePlace4: '',
      host4: '',
      record4: '',
      approvalStatus4: '',
      photo4: '',
      noteTaker4: '',
      consultNumber: '',
      communityId: '',
      negotiationContent: '',
      streetName: '',
      coordinateMethod: '',
      confirmateMethod: '',
    };
  },
  methods: {
    getData(){
      // alert(6666)
      this.communityName = '';
      this.consultTypeName = '';
      this.consultSure = '';
      this.content = '';
      this.bargainingLevel = '';
      this.issueSource = '';
      this.liyiList = [];
      this.ccList = [];
      this.handleTime = '';
      this.handlePlace = '';
      this.host = '';
      this.record = '';
      this.noteTaker = '';
      this.approvalStatus = '';
      this.photo = '';
      this.handleTime1 = '';
      this.handlePlace1 = '';
      this.host1 = '';
      this.record1 = '';
      this.approvalStatus1 = '';
      this.photo1 = '';
      this.noteTaker1 = '';
      this.handleTime2 = '';
      this.handlePlace2 = '';
      this.host2 = '';
      this.record2 = '';
      this.approvalStatus2 = '';
      this.photo2 = '';
      this.noteTaker2 = '';

      this.handleTime3 = '';
      this.handlePlace3 = '';
      this.host3 = '';
      this.record3 = '';
      this.approvalStatus3 = '';
      this.photo3 = '';
      this.noteTaker3 = '';

      this.handleTime4 = '';
      this.handlePlace4 = '';
      this.host4 = '';
      this.record4 = '';
      this.approvalStatus4 = '';
      this.photo4 = '';
      this.noteTaker4 = '';
      this.consultNumber = '';
      this.communityId = '';
      this.negotiationContent = '';
      this.streetName = '';
      this.coordinateMethod = '';
      this.confirmateMethod = '';
    },
    getFindConsultHandleList() {
      post("/admin/consultHandle/info/findConsultHandleList",{
        pageNo: 1,
        pageSize: 100,
        consultId: this.ytid
      }).then(res => {
        console.log(res)
        // 第一次办理记录
        this.handleTime = res.content.list[0].handleTime;
        this.handlePlace = res.content.list[0].handlePlace;
        this.host = res.content.list[0].host;
        this.record = res.content.list[0].record;
        this.noteTaker = res.content.list[0].noteTaker;
        this.photo = res.content.list[0].photo;
        console.log('photo', this.photo)
        if(res.content.list[0].approvalStatus == '0')  {
          this.approvalStatus = '已达成';
        }else if(res.content.list[0].approvalStatus == '1') {
          this.approvalStatus = '未达成';
        }
        // 第二次办理记录
        this.handleTime1 = res.content.list[1].handleTime;
        this.handlePlace1 = res.content.list[1].handlePlace;
        this.host1 = res.content.list[1].host;
        this.record1 = res.content.list[1].record;
        this.noteTaker1 = res.content.list[1].noteTaker;
        this.photo1 = res.content.list[1].photo;
        if(res.content.list[1].approvalStatus == '0')  {
          this.approvalStatus1 = '已达成';
        }else if(res.content.list[1].approvalStatus == '1') {
          this.approvalStatus1 = '未达成';
        }
        // 第三次办理记录
        this.handleTime2 = res.content.list[2].handleTime;
        this.handlePlace2 = res.content.list[2].handlePlace;
        this.host2 = res.content.list[2].host;
        this.record2 = res.content.list[2].record;
        this.noteTaker2 = res.content.list[2].noteTaker;
        this.photo2 = res.content.list[2].photo;
        if(res.content.list[2].approvalStatus == '0')  {
          this.approvalStatus2 = '已达成';
        }else if(res.content.list[2].approvalStatus == '1') {
          this.approvalStatus2 = '未达成';
        }
        // 第四次办理记录
        this.handleTime3 = res.content.list[3].handleTime;
        this.handlePlace3 = res.content.list[3].handlePlace;
        this.host3 = res.content.list[3].host;
        this.record3 = res.content.list[3].record;
        this.noteTaker3 = res.content.list[3].noteTaker;
        this.photo3 = res.content.list[3].photo;
        if(res.content.list[3].approvalStatus == '0')  {
          this.approvalStatus3 = '已达成';
        }else if(res.content.list[3].approvalStatus == '1') {
          this.approvalStatus3 = '未达成';
        }
         // 第五次办理记录
         this.handleTime4 = res.content.list[4].handleTime;
        this.handlePlace4 = res.content.list[4].handlePlace;
        this.host4 = res.content.list[4].host;
        this.record4 = res.content.list[4].record;
        this.noteTaker4 = res.content.list[4].noteTaker;
        this.photo4 = res.content.list[4].photo;
        if(res.content.list[4].approvalStatus == '0')  {
          this.approvalStatus4 = '已达成';
        }else if(res.content.list[4].approvalStatus == '1') {
          this.approvalStatus4 = '未达成';
        }
      }).catch(() => {});
    },
    getFindConsultById() {
      post("/admin/consult/info/findConsultById",{
        id: this.ytid
      }).then(res => {
        console.log(res)
        if(res.content.communityId == 2) {
          this.communityName = '浔河社区';
        }else if(res.content.communityId == 20) {
          this.communityName = '石街社区';
        }
        this.consultTypeName = res.content.consultTypeName;
        this.content = res.content.content;
        if(res.content.consultSure == '0'){
          this.consultSure = '是';
        }else if(res.content.consultSure == '1'){
          this.consultSure = '否';
        }
        //议题层级
        if(res.content.bargainingLevel == '1'){
          this.bargainingLevel = '涉及同一个村"两委"成员包组范围内1个或多个村(居)民组事项'
        }else if(res.content.bargainingLevel == '2'){
          this.bargainingLevel = '涉及1个村以上"两委"成员包组范围内1村(居)民组事项'
        }else if(res.content.bargainingLevel == '3'){
          this.bargainingLevel = '涉及与本镇内1个村以上范围事项'
        }else if(res.content.bargainingLevel == '4'){
          this.bargainingLevel = '涉及本镇以外其他镇的协商事项'
        }
        // 议题来源
        if(res.content.issueSource == '1'){
          this.issueSource = '党小组、村(居)民组会议';
        }else if(res.content.issueSource == '2'){
          this.issueSource = '群众通过电话或口头等方式';
        }else if(res.content.issueSource == '3'){
          this.issueSource = '群众通过微信、QQ等方式提出';
        }else if(res.content.issueSource == '4'){
          this.issueSource = '党员议事日';
        }else if(res.content.issueSource == '5'){
          this.issueSource = '意见箱';
        }else if(res.content.issueSource == '6'){
          this.issueSource = '包组干部收集到群众的需求';
        }else if(res.content.issueSource == '7'){
          this.issueSource = '落实上级党委政府工作安排';
        }else if(res.content.issueSource == '8'){
          this.issueSource = '其他';
        }
        this.consultNumber = res.content.consultNumber;
        this.communityId = res.content.communityId;
        this.negotiationContent = res.content.negotiationContent;
        this.streetName = res.content.streetName;
        this.coordinateMethod = res.content.coordinateMethod;
        this.confirmateMethod = res.content.confirmateMethod;
        if(res.content.confirmateMethod == '0') {
          this.confirmateMethod = '村"两委"会';
        }else if(res.content.confirmateMethod == '1') {
          this.confirmateMethod = '扩大会';
        }else if(res.content.confirmateMethod == '2') {
          this.confirmateMethod = '党员议事会';
        }
        console.log(res.content.persons)
        res.content.persons.forEach(item => {
          if(item.type== '0'){
            this.liyiList.push(item.name)
            
          }else if(item.type== '1'){
            this.ccList.push(item.name)
          }
        })
        
        this.liyiList = this.liyiList + '';
        this.ccList = this.ccList + '';
      console.log(this.liyiList)
      })
    }
  },
  mounted() {
    this.getFindConsultHandleList();
    this.getFindConsultById()
  }
};
</script>

<style lang="less" scoped>
.consulAddDialog {
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
.basicInfo {
  margin-bottom: 20px;
}
.queRenBtn {
  display: flex;
  justify-content: center;
}
.basicSecord {
    margin-top: 20px;
    margin-bottom: 20px;
}
.basicTable {
  display: flex;
  flex-direction: row;
  border-right: 1px solid #7d7d7d;
  border-bottom: 1px solid #7d7d7d;
  border-collapse: collapse;
}
.basicTable tr:nth-child(1) {
  width: 25%;
}
.basicTable tr:nth-child(2) {
  width: 35%;
}
.basicTable tr:nth-child(3) {
  width: 25%;
}
.basicTable tr:nth-child(4) {
  width: 35%;
}
.basicTable tr th {
//   width: 60px;
  height: 60px;
  display: flex;
  background: #eeeeee;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #7d7d7d;
  border-top: 1px solid #7d7d7d;
}
.basicTable tr td {
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #7d7d7d;
  border-top: 1px solid #7d7d7d; 
}
.tdspan{
  height: 50px;
  width: 90%;
  line-height: 50px;
  margin: 0 auto;
  text-align: left; 
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>